// Initialize Datadog RUM before any other module evaluates, so a throw
// later in the import chain can't prevent RUM from loading.
import "./datadog-init";

// Import main Less stylesheet (includes all other Less files)
import "../assets/less/styles.less";
import "./tailwind.css";

import React from "react";

import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import _ from "lodash";
import ReactDOM from "react-dom";
import Sifter from "sifter";

import publicConfig from "../public-config";
import RootMain from "../components/src/app-main/containers/RootMain";

// Expose RequireJS-era globals that 80+ files reference without importing
window._ = _;
// Sifter is consumed by shared-components/SearchWidget/ActivityInput/sift-activities.js
// via `new window.Sifter(...)`. Old main.js exposed it through RequireJS; this shim
// keeps the submodule untouched for other services that still bootstrap via AMD.
window.Sifter = Sifter;

// Google Maps JS API is consumed by shared-components/SearchWidget/utils/GoogleAutocomplete.js
// via `new window.google.maps.places.AutocompleteService()`. Old main.js loaded it through
// RequireJS using `window.googleAPIKey` rendered by the SSR mustache template; the new Vite
// setup has neither, so inject the script tag here using the runtime publicConfig key.
if (
  typeof document !== "undefined" &&
  publicConfig.google_maps_browser_key &&
  !document.getElementById("google-maps-js")
) {
  const script = document.createElement("script");
  script.id = "google-maps-js";
  script.async = true;
  script.defer = true;
  script.src = `https://maps.googleapis.com/maps/api/js?key=${publicConfig.google_maps_browser_key}&libraries=places`;
  document.head.appendChild(script);
}

// PSSessions: cookie helper used by http-v2, auth, navbar, etc.
// Was loaded via RequireJS in old main.js; must be imported before React mounts.
import "../lib/sessions.js";
// Initialize third-party libraries
window.jsPDF = jsPDF;
window.html2canvas = html2canvas;

// Note: Removed Intl polyfill check - modern browsers have native Intl support
// Old code (IE11-specific, from assets/js/main.js):
// if (!window.Intl) {
//   return requirejs(['intl'], function (Intl) {
//     window.Intl = Intl;
//     return loadMain();
//   });
// }

// Get initial state from server if available (unused until SSR is wired up)
window.__PRELOADED_STATE__ = window.__PRELOADED_STATE__ || {};

// Create root (React 18) or use render (React 17)
const root = document.getElementById("main-container");

try {
  if (ReactDOM.createRoot) {
    // React 18
    const reactRoot = ReactDOM.createRoot(root);
    reactRoot.render(<RootMain />);
  } else {
    // React 17
    ReactDOM.render(<RootMain />, root);
  }
} catch (e) {
  console.error("[main] render threw:", e);
}
